import React from "react";

const DollarSvg = (props) => (
  <svg viewBox="0 0 62.45 59.13" xmlns="http://www.w3.org/2000/svg" width="70" style={{ width: "70px" }} {...props}>
    <path d="M61.82 27.7H.63V.5h61.19z" fill="#fdba84" />
    <path
      d="M61.82 28.2H.63a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5h61.19a.5.5 0 0 1 .5.5v27.2a.5.5 0 0 1-.5.5zm-60.69-1h60.19V1H1.13z"
      fill="#ff4900"
    />
    <path
      d="M57.5 25.26H41l-1.01-1.71H22.9l-1.85 1.71H4.95V4.75H57.5z"
      fill="#fdd7b7"
      stroke="#ff4800"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.6 25.26H41.09l-1-1.71H23l-1.84 1.71H5V4.75a12 12 0 0 1 5.59 5.54c1.33 2.52 2.24 8.91 6.47 10.38 2.25.78 24.73 2.72 28.47.56 6.38-3.68 11.68 2.16 11.68 2.16z"
      fill="#ff4800"
      opacity={0.1}
    />
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="M23.73 26.37H38.7" fill="#fd9040" stroke="#fe6d18" />
      <ellipse
        cx={31.13}
        cy={15.23}
        fill="#fff"
        rx={9.07}
        ry={11.33}
        stroke="#ff4900"
      />
      <ellipse
        cx={6.16}
        cy={7.53}
        fill="#fff"
        rx={3.4}
        ry={4.53}
        stroke="#ff4800"
        strokeWidth={0.8}
      />
      <ellipse
        cx={56.48}
        cy={7.53}
        fill="#fff"
        rx={3.4}
        ry={4.53}
        stroke="#ff4800"
        strokeWidth={0.8}
      />
      <ellipse
        cx={5.03}
        cy={23.39}
        fill="#fff"
        rx={2.27}
        ry={2.72}
        stroke="#ff4800"
        strokeWidth={0.8}
      />
      <ellipse
        cx={57.16}
        cy={23.39}
        fill="#fff"
        rx={2.27}
        ry={2.72}
        stroke="#ff4800"
        strokeWidth={0.8}
      />
    </g>
    <path
      d="m33.79 1.41.67.92s24.95-.77 25.42 0 .65 15.62.84 16.82a11 11 0 0 0 1.1 2.85V1.41z"
      fill="#ff4900"
      opacity={0.1}
    />
    <path
      d="M3.72 7.17c0 2.5 1.18 3.69 2.52 4.89-1.88 0-3.4-2-3.4-4.53S4.36 3 6.24 3C4.78 4.28 3.72 5.13 3.72 7.17z"
      fill="#ff4800"
      opacity={0.2}
    />
    <path
      d="M54 7.17c0 2.5 1.18 3.69 2.52 4.89-1.88 0-3.4-2-3.4-4.53S54.6 3 56.48 3C55 4.28 54 5.13 54 7.17z"
      fill="#ff4800"
      opacity={0.3}
    />
    <path
      d="M3.5 23.22c0 1.5.34 1.68 1.53 2.89a2.53 2.53 0 0 1-2.27-2.72A2.53 2.53 0 0 1 5 20.67c0 .16-1.55 1-1.5 2.55zM55.63 23.22c0 1.5.33 1.68 1.53 2.89a2.52 2.52 0 0 1-2.27-2.72 2.52 2.52 0 0 1 2.27-2.72c0 .16-1.58 1-1.53 2.55z"
      fill="#ff4800"
      opacity={0.2}
    />
    <path
      d="M34.82 17.89a2.68 2.68 0 0 1-1 2.16 3.9 3.9 0 0 1-2.28.84v.92h-.9v-1c-.07 0-.57-.17-1.51-.47a1.33 1.33 0 0 0-.3-.08c-.19 0-.31.18-.36.53h-.65l-.52-3.68h.7c.59 1.62 1.48 2.53 2.65 2.74v-4a10.65 10.65 0 0 1-1.94-1.32 2.78 2.78 0 0 1-.94-2.08v-.08a2.69 2.69 0 0 1 .83-2 3 3 0 0 1 2-.85v-.84h.89v1.05l.74.26a2.4 2.4 0 0 0 .76.16c.23 0 .41-.17.54-.52h.59l.34 3.69h-.66c-.57-1.58-1.34-2.47-2.32-2.67v3.4a15.81 15.81 0 0 1 2.19 1.5 3.14 3.14 0 0 1 1.15 2.34zm-4.16-7.24a1.59 1.59 0 0 0-.81.47 1.17 1.17 0 0 0-.33.82c0 .5.38 1 1.14 1.54zm2.23 7.65c0-.65-.45-1.26-1.35-1.84v3.45a1.63 1.63 0 0 0 1-.55 1.56 1.56 0 0 0 .35-1.06z"
      fill="#ff4900"
    />
  </svg>
);

export default DollarSvg;
